module.exports = __webpack_public_path__ + "static/media/course11.846f1d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/course11.png
// module id = 2849
// module chunks = 0